import store from '@/store';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import debounce from '@/utils/Debounce';
import { FilterKey } from '@studyportals/search-filters/server-side';
import { FacetValues } from '@studyportals/search-api-interface';
import { disciplinesAll } from '@studyportals/static-domain-data/disciplines/disciplines';

export default class Disciplines {
	containerRef = ref<HTMLElement | null>(null);

	constructor() {
		onMounted(() => {
			this.setupScrollListener();
		});

		onUnmounted(() => {
			this.removeScrollListener();
		});
	}

	public topLevelDisciplines = computed(():FacetValues[] =>
		//Checking against disciplines on static domain data to ensure the correct disciplines are displayed
		store.getters.getFacets(FilterKey.DISCIPLINES)
			.filter(f=> disciplinesAll.some(ds => ds.id === f.value))
	)

	private isMobileDevice(): boolean {
		return window.innerWidth <= 768;
	}

	private handleScroll = (): void => {
		if (!this.isMobileDevice()) return;
		const activeEl = document.activeElement as HTMLElement | null;
		if (!activeEl) return;

		activeEl.blur();
	};

	private handleScrollDebounced = debounce(this.handleScroll, 50);

	private setupScrollListener(): void {
		if (!this.isMobileDevice()) return;
		if (this.containerRef.value) {
			this.containerRef.value.addEventListener('scroll', this.handleScrollDebounced, { passive: true });
		}
	}

	private removeScrollListener(): void {
		if (this.containerRef.value) {
			this.containerRef.value.removeEventListener('scroll', this.handleScrollDebounced);
		}
	}
}